import {IABTestingState} from "../types/IABTestingState";

export const abTestingSelector = (abTestId: string) => (state: IABTestingState) => state.abTesting.tests[abTestId];
import {IABTestingState} from "../types/IABTestingState";

export const abTestingSelector = (abTestId: string) => (state: IABTestingState) => state.abTesting.tests[abTestId];
